// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimTransferCreateDto
 */
export interface IClaimTransferCreateDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimTransferCreateDto
     */
    account_from: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimTransferCreateDto
     */
    account_to: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimTransferCreateDto
     */
    amount: number;
}

/**
 * Check if a given object implements the IClaimTransferCreateDto interface.
 */
export function instanceOfIClaimTransferCreateDto(value: object): value is IClaimTransferCreateDto {
    if (!('account_from' in value) || value['account_from'] === undefined) return false;
    if (!('account_to' in value) || value['account_to'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function IClaimTransferCreateDtoFromJSON(json: any): IClaimTransferCreateDto {
    return IClaimTransferCreateDtoFromJSONTyped(json, false);
}

export function IClaimTransferCreateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimTransferCreateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'account_from': json['account_from'],
        'account_to': json['account_to'],
        'amount': json['amount'],
    };
}

export function IClaimTransferCreateDtoToJSON(json: any): IClaimTransferCreateDto {
    return IClaimTransferCreateDtoToJSONTyped(json, false);
}

export function IClaimTransferCreateDtoToJSONTyped(value?: IClaimTransferCreateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_from': value['account_from'],
        'account_to': value['account_to'],
        'amount': value['amount'],
    };
}

